import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import logo from '../assets/Logo_Staisch_innovative_Elektrotechnik.png';

export const Impressum = () => (
  <>
    <section className="page-hero page-hero--small" id="top">
      <div className="container page-hero__inner">
        <div>
          <span className="section__eyebrow">Rechtliche Angaben</span>
          <h1>Impressum</h1>
          <p className="page-hero__lead">
            Angaben gemäß § 5 TMG für den Internetauftritt von Staisch Innovative Elektrotechnik.
          </p>
        </div>
      </div>
    </section>

    <section className="section legal">
      <div className="container">
        <div className="grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
          <Card className="bg-white/90 shadow-md backdrop-blur dark:bg-slate-900/70">
            <CardHeader className="pb-3">
              <CardTitle className="text-lg">Staisch Innovative Elektrotechnik</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3 text-sm text-slate-600 dark:text-slate-300">
              <p>Inhaber</p>
              <p className="font-semibold text-slate-900 dark:text-white">Adrian Staisch</p>
              <p>Elektrotechniker-Meister</p>
              <p className="pt-2 font-semibold text-slate-900 dark:text-white">Adresse</p>
              <p>
                Freiherr-vom-Stein-Straße 14
                <br />
                72654 Neckartenzlingen
              </p>
              <p className="pt-2 font-semibold text-slate-900 dark:text-white">Email</p>
              <p>
                <a
                  className="font-medium text-blue-600 hover:underline"
                  href="mailto:info@staisch-elektrotechnik.de"
                >
                  info@staisch-elektrotechnik.de
                </a>
              </p>
              <p className="pt-2 font-semibold text-slate-900 dark:text-white">Telefon</p>
              <p>
                <a className="font-medium text-blue-600 hover:underline" href="tel:015758166291">
                  01575 8166291
                </a>
              </p>
              <p className="pt-2 font-semibold text-slate-900 dark:text-white">Steuernummer:</p>
              <p>2874408/59555</p>
              <p className="pt-2 font-semibold text-slate-900 dark:text-white">USt-IdNr.:</p>
              <p>DE306179193</p>
            </CardContent>
          </Card>

          <Card className="bg-white/90 shadow-md backdrop-blur dark:bg-slate-900/70">
            <CardContent className="flex h-full items-center justify-center p-8">
              <img src={logo} alt="Staisch Innovative Elektrotechnik" className="h-64 w-auto" />
            </CardContent>
          </Card>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-3">
          <Card className="bg-white/90 shadow-md backdrop-blur dark:bg-slate-900/70">
            <CardHeader className="pb-3">
              <CardTitle className="text-lg">Haftungshinweis</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-slate-600 dark:text-slate-300">
              <p>
                Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die
                Inhalte externer Links. Für den Inhalt verlinkter Seiten sind ausschließlich deren
                Betreiber verantwortlich.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-white/90 shadow-md backdrop-blur dark:bg-slate-900/70">
            <CardHeader className="pb-3">
              <CardTitle className="text-lg">Bildrechte</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3 text-sm text-slate-600 dark:text-slate-300">
              <p>Die auf dieser Internetseite verwendeten Bilder stammen aus folgenden Webseiten:</p>
              <ul className="list-disc pl-5">
                <li>www.jung.de</li>
                <li>www.hager.de</li>
                <li>www.trio-leuchten.de</li>
                <li>www.metz-connect.de</li>
                <li>www.eielectronics.de</li>
                <li>www.pixabay.com</li>
              </ul>
              <p>
                Sie sind nicht berechtigt diese herunterzuladen sowie zu vervielfältigen, auch nicht
                zum privaten Gebrauch. Die genauen Angaben zu den Quellen und zu den Nutzerrechten
                erhalten Sie auf Anfrage.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-white/90 shadow-md backdrop-blur dark:bg-slate-900/70">
            <CardHeader className="pb-3">
              <CardTitle className="text-lg">Datenschutzhinweis</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-slate-600 dark:text-slate-300">
              <p>
                Von Ihnen per Kontaktformular gesendete Daten werden bei uns im Hause nur für
                Kontaktzwecke eingesetzt (z.B. um Ihre Anfrage zu bearbeiten). Ihre Daten werden
                nicht an andere Unternehmen weitergegeben. Wenn Sie wünschen löschen wir Ihre Daten
                unverzüglich aus unserem System, senden Sie uns dazu bitte eine E-Mail.
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="mt-10">
          <Card className="bg-white/90 shadow-md backdrop-blur dark:bg-slate-900/70">
            <CardHeader className="pb-3">
              <CardTitle className="text-lg">Disclaimer</CardTitle>
            </CardHeader>
            <CardContent className="space-y-6 text-sm text-slate-600 dark:text-slate-300">
              <p>
                Unsere Webseiten sind urheberrechtlich geschützt. Jede Verwertung zu kommerziellen
                oder politischen Zwecken, sei es ganz oder teilweise, auch in veränderter Form
                bedarf der vorherigen Zustimmung. Zulässig ist der Ausdruck, die Kopie oder das
                Herunterladen von Dateien zu Informationszwecken sowie zum Zwecke der privaten
                Nutzung. Die in unseren Webseiten enthaltenen Links können dazu führen, daß Sie auf
                die Webseiten Dritter gelangen. Wir weisen darauf hin, dass wir auf diese Webseiten
                keinen Einfluss haben, und daher auch nicht für deren Inhalt verantwortlich sind.
                Die Existenz von Links zu Webseiten Dritter stellt keine Empfehlung für diese
                Seiten, die sie betreibenden Unternehmen oder deren Produkte und Leistungen dar.
                Unsere Webseiten haben wir sehr sorgfältig zusammengestellt. Für die Richtigkeit
                und Vollständigkeit der Angaben können wir dennoch keine Haftung übernehmen. Die
                Inhalte können überdies ohne vorherige Ankündigung aktualisiert, erweitert, gekürzt
                oder anderweitig angepasst oder geändert werden.
              </p>

              <div className="space-y-2">
                <p className="font-semibold text-slate-900 dark:text-white">1. Inhalt des Onlineangebotes</p>
                <p>
                  Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit,
                  Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche
                  gegen den Autor, welche sich auf Schäden materieller oder ideeller Art beziehen, die
                  durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die
                  Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind
                  grundsätzlich ausgeschlossen, sofern seitens des Autors kein nachweislich
                  vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle Angebote sind
                  freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile
                  der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu
                  ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
                </p>
              </div>

              <div className="space-y-2">
                <p className="font-semibold text-slate-900 dark:text-white">2. Verweise und Links</p>
                <p>
                  Bei direkten oder indirekten Verweisen auf fremde Webseiten („Hyperlinks“), die
                  außerhalb des Verantwortungsbereiches des Autors liegen, würde eine
                  Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in dem der Autor
                  von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die
                  Nutzung im Falle rechtswidriger Inhalte zu verhindern. Der Autor erklärt hiermit
                  ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den zu
                  verlinkenden Seiten erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die
                  Inhalte oder die Urheberschaft der verlinkten/verknüpften Seiten hat der Autor
                  keinerlei Einfluss. Deshalb distanziert er sich hiermit ausdrücklich von allen
                  Inhalten aller verlinkten/verknüpften Seiten, die nach der Linksetzung verändert
                  wurden. Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes
                  gesetzten Links und Verweise sowie für Fremdeinträge in vom Autor eingerichteten
                  Gästebüchern, Diskussionsforen, Linkverzeichnissen, Mailinglisten und in allen
                  anderen Formen von Datenbanken, auf deren Inhalt externe Schreibzugriffe möglich
                  sind. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für
                  Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen
                  entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht
                  derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist.
                </p>
              </div>

              <div className="space-y-2">
                <p className="font-semibold text-slate-900 dark:text-white">3. Urheber- und Kennzeichenrecht</p>
                <p>
                  Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten
                  Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst
                  erstellte Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder
                  auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen.
                  Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten
                  Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils
                  gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen
                  Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass
                  Markenzeichen nicht durch Rechte Dritter geschützt sind! Das Copyright für
                  veröffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim Autor der
                  Seiten. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente,
                  Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist
                  ohne ausdrückliche Zustimmung des Autors nicht gestattet.
                </p>
              </div>

              <div className="space-y-2">
                <p className="font-semibold text-slate-900 dark:text-white">4. Datenschutz</p>
                <p>
                  Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe persönlicher oder
                  geschäftlicher Daten (Emailadressen, Namen, Anschriften) besteht, so erfolgt die
                  Preisgabe dieser Daten seitens des Nutzers auf ausdrücklich freiwilliger Basis. Die
                  Inanspruchnahme und Bezahlung aller angebotenen Dienste ist – soweit technisch
                  möglich und zumutbar – auch ohne Angabe solcher Daten bzw. unter Angabe anonymisierter
                  Daten oder eines Pseudonyms gestattet. Die Nutzung der im Rahmen des Impressums oder
                  vergleichbarer Angaben veröffentlichten Kontaktdaten wie Postanschriften, Telefon-
                  und Faxnummern sowie Emailadressen durch Dritte zur Übersendung von nicht ausdrücklich
                  angeforderten Informationen ist nicht gestattet. Rechtliche Schritte gegen die
                  Versender von sogenannten Spam-Mails bei Verstössen gegen dieses Verbot sind
                  ausdrücklich vorbehalten.
                </p>
              </div>

              <div className="space-y-2">
                <p className="font-semibold text-slate-900 dark:text-white">
                  5. Rechtswirksamkeit dieses Haftungsausschlusses
                </p>
                <p>
                  Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem
                  aus auf diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses
                  Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen
                  sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit
                  davon unberührt.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  </>
);
